export const timeFormat = 'yyyy-MM-dd HH:mm';
export const dateFormat = 'yyyy-MM-dd';
export const timeFormatWithSeconds = timeFormat + ':ss';
